<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kqG3aQ/tc-custom/9780544003088.jpg?1721057546865" alt="This image is the cover for the book Imaginary Magnitude"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Imaginary Magnitude
      </h1>
      <p class="bookDescription body article font2">
        <p>These wickedly authentic introductions to twenty-first-century books preface tomes on teaching English to bacteria, using animated X-rays to create "pornograms," and analyzing computer-generated literature through the science of "bitistics." "Lem, a science fiction Bach, plays in this book a googleplex of variations on his basic themes" (New York Times Book Review). Translated by Marc E. Heine. A Helen and Kurt Wolff Book<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stanislaw Lem
      </h2>
      
      <p class="authorDescription body article">Stanislaw Lem (1921-2006) was the most widely translated and best known science fiction author writing outside of the English language. Winner of the Kafka Prize, he was a contributor to many magazines, including the <I>New Yorker,</I> and the author of numerous works, including <I>Solaris.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?27ab7c81